import React from 'react';
import { User, ArrowRight, Check, Hash, Shield, Lock } from 'lucide-react';

function ConfirmCustDeatil({ data, onContinue }) {
    
  return (
<div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-[100dvh] flex items-center justify-center px-4 py-6 sm:px-6 sm:py-12">
  <div className="w-full max-w-md sm:max-w-2xl">

    {/* Header Card */}
    <div className="bg-gradient-to-r from-[#472f92] to-[#6a4bc5] shadow-xl rounded-2xl p-5 sm:p-8 text-white mb-6 transition-all">
      <div className="flex flex-col items-center text-center">

        <div className="flex items-center justify-center mb-3 sm:mb-4">
          <User className="w-12 h-12 sm:w-16 sm:h-16 text-white" />
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold mb-2 tracking-tight">
          Verify Customer Details
        </h2>

        <div className="h-1 w-20 sm:w-24 bg-gradient-to-r from-[#e4aa24] to-[#f2c94c] rounded-full mb-3 sm:mb-4"></div>

        <p className="text-purple-100 text-sm sm:text-lg max-w-sm">
          Please confirm the following details before proceeding with verification
        </p>

        {/* Decorative dots */}
        <div className="flex mt-4 sm:mt-6 space-x-2">
       
          <div className="w-2.5 h-2.5 rounded-full bg-white/50" />
          <div className="w-2.5 h-2.5 rounded-full bg-white/70" />
          <div className="w-2.5 h-2.5 rounded-full bg-[#e4aa24]" />
          <div className="w-2.5 h-2.5 rounded-full bg-white/70" />
        
        </div>
      </div>
    </div>

    {/* Details Card */}
    <div className="bg-white shadow-xl rounded-2xl border border-gray-100">
      <div className="p-6 sm:p-10">

        {/* Section Header */}
        <div className="mb-4 flex items-center">
          <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-purple-50 flex items-center justify-center mr-3">
            <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-md bg-gradient-to-r from-[#472f92] to-[#6a4bc5] flex items-center justify-center">
              <Check className="w-3 h-3 text-white" />
            </div>
          </div>
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800">
            Customer Information
          </h3>
        </div>

        <p className="text-gray-500 text-sm sm:text-base mb-6">
          Review and confirm these details
        </p>

        {/* Info Cards */}
        <div className="space-y-4 sm:space-y-6 mb-8">

          <div className="border border-gray-200 rounded-xl p-4 sm:p-5 bg-gradient-to-r from-gray-50 to-white transition-all">
            <div className="flex items-center mb-1">
              <div className="w-8 h-8 rounded-md bg-blue-100 flex items-center justify-center mr-3">
                <User className="w-4 h-4 text-blue-600" />
              </div>
              <span className="text-sm font-medium text-gray-500">
                Full Name
              </span>
            </div>
            <div className="text-lg sm:text-xl font-bold text-gray-800 pl-11">
              {data?.data.customerName || "N/A"}
            </div>
          </div>

        </div>

        {/* Action Button */}
        <div className="pt-5 border-t border-gray-100">
          <button
            onClick={onContinue}
            className="w-full bg-gradient-to-r from-[#472f92] via-[#5a3cad] to-[#e4aa24] text-white py-3.5 sm:py-4 rounded-xl font-bold text-base sm:text-lg shadow-md transition-all flex items-center justify-center gap-3 active:scale-[0.98]"
          >
            <span>Verify with Fayda</span>
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
              <ArrowRight className="w-5 h-5" />
            </div>
          </button>
        </div>

      </div>
    </div>

  </div>
</div>

  );
}

export default ConfirmCustDeatil;